import React from "react";
import { serverURL } from "../../../utils/serverURL";
import axios from "axios";

const Post = ({ post }) => {
  const userEmail = sessionStorage.getItem("userEmail");
  const addPoint = async (obj) => {
    try {
      const responseP = await axios.post(`${serverURL}point/awardPoint`, {
        pointObj: obj,
      });      
    } catch (error) {
      console.log(error);
    }
  };
  function handleMetaversePageClick() {
    if (userEmail) {
      let pointObj = {
        email: userEmail,
        ActivityType: "New Article Share",
        ActivityName: post?.title,
        ActivityId: null,
        Details: "News Article Share Details",
      };
      addPoint(pointObj);
    }
  }
  return (
    <div>
      <div className="nk-post-text mt-0">
        <div className="nk-post-img">
          <div
            className="news-body-img"
            style={{
              backgroundImage: `url(${serverURL + post?.imageLarge})`,
            }}
          />
        </div>
        <div className="nk-gap-1"></div>
        <h1 className="nk-post-title h4">{post?.title}</h1>
        <div className="nk-post-by">
          <img
            src={post?.author?.image}
            alt="Post Image"
            className="rounded-circle"
            width="35"
          />{" "}
          by <a href="http://rare.land/">{post?.author?.name}</a> in{" "}
          {post?.updatedAt?.toString().substring(0, 10)}{" "}
          <div className="nk-post-categories" />
          {post?.categories.map((cat) => (
            <span className="bg-main-1 p-2 m-1 font-weight-bold">{cat.name}</span>
          ))}
        </div>
      </div>
      <div className="nk-gap"></div>
      {post?.body}
      <div className="nk-gap"></div>
      <div className="nk-post-share">
        <span className="h5">Share Article:</span>
        <ul className="nk-social-links-2">
        {/*   <li>
            <span
              className="nk-social-facebook"
              title="Share page on Facebook"
              data-share="facebook"
              onClick={handleMetaversePageClick}
            >
              <svg
                classname="svg-inline--fa fa-facebook fa-w-16"
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="facebook"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
                ></path>
              </svg>{" "}
              <span className="fab fa-facebook"></span>{" "}
            </span>
          </li> */}
          <li>
            <span
              className="nk-social-twitter"
              title="Share page on Twitter"
              data-share="twitter"
              onClick={handleMetaversePageClick}
            >
              <svg
                className="svg-inline--fa fa-twitter fa-w-16"
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="twitter"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                ></path>
              </svg>{" "}
              <span className="fab fa-twitter"></span>{" "}
            </span>
          </li>          
        </ul>
      </div>
    </div>
  );
};

export default Post;
